// removed by extract-text-webpack-plugin
module.exports = {"SimillarBeers":"SimillarBeers__SimillarBeers__-hash-base-64-5-","Image":"SimillarBeers__Image__-hash-base-64-5-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/presentational/SimillarBeers/SimillarBeers.scss
// module id = 188
// module chunks = 0